import { _ } from '@ngx-translate/core';
import { LegendItemType } from '@src/app/components/legend';

export const LEGEND_ITEMS: Array<LegendItemType> = [
  {
    color: 'var(--tui-chart-categorical-00)',
    label: _('components.lpStatisticsBarChart.constants.legendItems.display'),
  },
  {
    color: 'var(--tui-chart-categorical-01)',
    label: _('components.lpStatisticsBarChart.constants.legendItems.clicks'),
  },
  {
    color: 'var(--tui-chart-categorical-02)',
    label: _('components.lpStatisticsBarChart.constants.legendItems.discounts'),
  },
  {
    color: 'var(--tui-chart-categorical-03)',
    label: _('components.lpStatisticsBarChart.constants.legendItems.contactsSent'),
  },
];
